import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"sync\"><g id=\"icon\"><g id=\"Arrow\"><path id=\"Ellipse 4\" d=\"M20.1568 8.19644C19.3127 6.38623 17.8904 4.90824 16.1139 3.99525C14.3374 3.08227 12.3077 2.78617 10.3444 3.15358C8.38118 3.521 6.59591 4.53105 5.26982 6.02466C3.94373 7.51827 3.15216 9.41058 3.01979 11.4035\" stroke-linecap=\"round\"></path><path id=\"Arrow_2\" d=\"M20.6036 4.77029L20.177 8.2442L16.7031 7.81766\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><g id=\"Arrow_3\"><path id=\"Ellipse 4_2\" d=\"M3.84323 15.8036C4.68734 17.6138 6.10964 19.0918 7.88612 20.0047C9.66259 20.9177 11.6923 21.2138 13.6556 20.8464C15.6188 20.479 17.4041 19.469 18.7302 17.9753C20.0563 16.4817 20.8478 14.5894 20.9802 12.5965\" stroke-linecap=\"round\"></path><path id=\"Arrow_4\" d=\"M3.39645 19.2297L3.82299 15.7558L7.2969 16.1823\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }